import { z } from "zod";

/** POST /v1/me/payment-methods/setup-intent → istemci kartı Stripe'ta bu sırla kaydeder (3DS dahil, K-017) */
export interface SetupIntentResponse {
  setupIntentId: string;
  clientSecret: string;
}

/** POST /v1/me/payment-methods/confirm — Stripe'ta tamamlanan kart kaydı Poji'ye işlenir */
export const ConfirmCardBody = z.object({ setupIntentId: z.string().min(3).max(255) });
export type ConfirmCardBody = z.infer<typeof ConfirmCardBody>;

export interface PaymentMethodView {
  id: string;
  brand: string | null;
  last4: string | null;
  expMonth: number | null;
  expYear: number | null;
  isDefault: boolean;
}

/** POST /v1/provider/payout-account — hizmet verenin Stripe'ta ödeme bilgilerini girdiği sayfa (K-014) */
export interface PayoutAccountResponse {
  status: "not_connected" | "pending" | "enabled" | "restricted";
  onboardingUrl: string | null;
}
